import { createDeactivationURL } from './links';
import { linkStyles, setStyleAttribute } from './styles';
import type { DeactivationConfig } from './types';

const DEFAULT_TEXT = 'Widget is deactivated. Please, visit Elfsight Apps.';

export function Deactivation({
  appAlias,
  displayDeactivation = false,
  deactivationURL,
  text = DEFAULT_TEXT,
  style
}: DeactivationConfig) {
  const url = createDeactivationURL(deactivationURL, appAlias);

  if (!displayDeactivation) {
    return null;
  }

  return (
    <a
      href={url.toString()}
      target="_blank"
      rel="noreferrer"
      ref={(el) =>
        setStyleAttribute(el, {
          ...linkStyles,
          ...style
        })
      }
    >
      {text}
    </a>
  );
}
